"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormError = _interopRequireDefault(require("./FormError"));

var _FormLabel = _interopRequireDefault(require("./FormLabel"));

var _KeyboardUtils = _interopRequireDefault(require("../../util/KeyboardUtils"));

var _PropUtils = require("../../util/PropUtils");

var _InputWidths = require("./InputWidths");

var _classnames = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @callback FormCheckbox~onChange
 *
 * @param {object} e
 *    The ReactJS synthetic event object.
 */

/**
* @callback FormCheckbox~onValueChange
*
* @param {boolean} checked
*    The current checked state.
*/

/**
 * @class FormCheckbox
 * @desc A checkbox field component.
 *
 * @param {string} [className]
 *    CSS classes to set on the top-level HTML container.
 * @param {string} [data-id="form-checkbox-container"]
 *    To define the base "data-id" value for the top-level HTML container.
 *    Note that "-container" will be appended to the "data-id" set on the top-level HTML container,
 *    and the "data-id" string will be set on the checkbox "input" elelment under the top-level HTML container.
 * @param {node} [errorMessage]
 *    The message to display if defined when external validation failed.
 * @param {node} [label]
 *    Label text to be displayed.
 * @param {string} [hint]
 *    Label help text to be displayed.
 * @param {string} [helpHintText]
 *    Alias for hint
 * @param {string} [helpClassName]
 *    CSS classes to set on the HelpHint component.
 * @param {string} [name]
 *    The name value for the input.
 * @param {function} [renderLabel]
 *    Render prop to display FormLabel
 * @param {string} [value]
 *    The value for the input.
* @param {InputWidths} [width]
*    Specifies the width of the input.
 *
 * @param {boolean} [checked=false]
 *    Whether or not the checkbox is checked.
 * @param {boolean} [disabled=false]
 *    If true, disables current checkbox and styles opacity.
 * @param {boolean} [inline=false]
 *    If true, adds "inline" className for inline boxes
 * @param {boolean} [stacked=false]
 *    If true, adds "stacked" className for label on right side
 *
 * @param {object} [helpTarget]
 *     An optional icon or image to replace standard help hint icon
 *
 * @param {FormCheckbox~onChange} [onChange]
 *    Callback to be triggered when checkbox is toggled. It will receive the triggering event.
 * @param {FormCheckbox~onValueChange} ]onValueChange]
 *    Callback to be triggered when checkbox is toggled. It will receive the component's value.
 * @param {boolean} [noSpacing=false]
 *    Removes margins
 *
 * @example
 *
 *     <FormCheckbox label="Regular Checkbox"
 *         data-id="form-checkbox"
 *         onChange={this._changeCallback}
 *     />
 */
var FormCheckboxBase = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(FormCheckboxBase, _React$Component);

  var _super = _createSuper(FormCheckboxBase);

  function FormCheckboxBase() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, FormCheckboxBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleChange", function (e) {
      if (_this.props.onChange) {
        _this.props.onChange(e);
      }

      if (_this.props.onValueChange) {
        _this.props.onValueChange(!!e.target.checked, e);
      }
    });
    return _this;
  }

  (0, _createClass2.default)(FormCheckboxBase, [{
    key: "render",
    value: function render() {
      var labelClassName = (0, _classnames.default)("input-checkbox", this.props.className, (0, _InputWidths.getInputWidthClass)({
        className: this.props.className,
        defaultClass: null,
        width: this.props.width
      }), {
        disabled: this.props.disabled,
        "form-error": this.props.errorMessage,
        stacked: this.props.stacked,
        inline: this.props.inline
      });
      var _this$props = this.props,
          checked = _this$props.checked,
          conditionalContent = _this$props.conditionalContent,
          dataId = _this$props["data-id"],
          helpClassName = _this$props.helpClassName,
          helpTarget = _this$props.helpTarget,
          disabled = _this$props.disabled,
          errorMessage = _this$props.errorMessage,
          label = _this$props.label,
          labelHelpText = _this$props.labelHelpText,
          _this$props$hint = _this$props.hint,
          hint = _this$props$hint === void 0 ? labelHelpText : _this$props$hint,
          _this$props$name = _this$props.name,
          name = _this$props$name === void 0 ? dataId : _this$props$name,
          noSpacing = _this$props.noSpacing,
          _this$props$value = _this$props.value,
          value = _this$props$value === void 0 ? dataId : _this$props$value,
          stacked = _this$props.stacked;
      var checkBox = this.props.renderLabel({
        "data-id": "".concat(dataId, "-container"),
        className: labelClassName,
        helpClassName: helpClassName,
        helpTarget: helpTarget,
        disabled: disabled,
        value: label,
        hint: hint,
        children: [/*#__PURE__*/_react.default.createElement("input", {
          "data-id": dataId,
          type: "checkbox",
          name: name,
          value: value,
          onChange: this._handleChange,
          checked: checked,
          disabled: disabled,
          key: "input"
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "icon",
          key: "icon"
        }), errorMessage && /*#__PURE__*/_react.default.createElement(_FormError.default.Icon, {
          "data-id": "".concat(dataId, "-error-message-icon"),
          key: "errorIcon"
        }), errorMessage && /*#__PURE__*/_react.default.createElement(_FormError.default.Message, {
          value: errorMessage,
          "data-id": "".concat(dataId, "-error-message"),
          key: "errorMessage"
        })],
        noSpacing: noSpacing
      }, _FormLabel.default);
      var showConditionalContent = conditionalContent && checked ? /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)("input-checkbox__conditional-content", {
          "input-checkbox__conditional-content--stacked": stacked
        })
      }, conditionalContent) : null;
      return stacked || showConditionalContent ? /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)({
          "input-checkbox__container--stacked": stacked
        })
      }, checkBox, showConditionalContent) : checkBox;
    }
  }]);
  return FormCheckboxBase;
}(_react.default.Component);

(0, _defineProperty2.default)(FormCheckboxBase, "propTypes", {
  className: _propTypes.default.string,
  checked: _propTypes.default.bool,
  conditionalContent: _propTypes.default.node,
  content: _propTypes.default.node,
  "data-id": _propTypes.default.string,
  disabled: _propTypes.default.bool,
  errorMessage: _propTypes.default.node,
  helpClassName: _propTypes.default.string,
  helpTarget: _propTypes.default.node,
  inline: _propTypes.default.bool,
  label: _propTypes.default.node,
  labelHelpText: _propTypes.default.string,
  // use hint instead
  hint: _propTypes.default.string,
  name: _propTypes.default.string,
  noSpacing: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onValueChange: _propTypes.default.func,
  stacked: _propTypes.default.bool,
  renderLabel: _propTypes.default.func,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  width: _propTypes.default.oneOf(_InputWidths.InputWidthProptypes)
});
(0, _defineProperty2.default)(FormCheckboxBase, "defaultProps", {
  checked: false,
  "data-id": "form-checkbox",
  disabled: false,
  inline: false,
  noSpacing: false,
  stacked: false,
  renderLabel: _PropUtils.defaultRender
});

var FormCheckbox = _KeyboardUtils.default.withFocusOutline(FormCheckboxBase);

module.exports = FormCheckbox;